import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CheckCircle2Icon, XIcon } from "lucide-react";
import { images, purchaseNotifications } from "../data/landingContent";
const FIRST_DELAY = 6000;
const VISIBLE_FOR = 5000;
const INTERVAL = 14000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [minutesAgo, setMinutesAgo] = useState(2);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    const show = () => {
      setIndex(i => (i + 1) % purchaseNotifications.length);
      setMinutesAgo(Math.floor(Math.random() * 9) + 1);
      setVisible(true);
      hideTimer = window.setTimeout(() => setVisible(false), VISIBLE_FOR);
    };
    const first = window.setTimeout(show, FIRST_DELAY);
    const loop = window.setInterval(show, INTERVAL);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(loop);
    };
  }, [dismissed]);
  const buyer = purchaseNotifications[index];
  return <AnimatePresence data-id="element-47" data-mp="1151xjzwzatmy">
      {visible && !dismissed && <motion.div key={buyer.name} role="status" initial={{
      opacity: 0,
      y: -16,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: -16,
      scale: 0.96
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed left-3 right-3 top-3 z-50 mx-auto flex max-w-sm items-center gap-3 rounded-2xl border border-rose/20 bg-white p-3 pr-9 shadow-[0_16px_40px_-12px_rgba(78,26,55,0.35)] sm:left-5 sm:right-auto sm:top-auto sm:bottom-24" data-id="element-48" data-mp="1fuhaabzocyjn">
          <img src={images.hero} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-blush object-contain p-1" data-id="element-49" data-mp="28kg22f5979s0" />
          <div className="min-w-0" data-id="element-50" data-mp="23kv344q331fa">
            <p className="text-sm leading-snug text-ink" data-id="element-51" data-mp="2aol7cla0kq6y">
              <span className="font-bold" data-id="element-52" data-mp="2ao1mowszbnp8">{buyer.name}</span> from {buyer.flag} {buyer.country}
            </p>
            <p className="text-sm leading-snug text-muted" data-id="element-53" data-mp="2fltfdt1g7duh">just purchased Menopause Decision Map™</p>
            <p className="mt-0.5 flex items-center gap-1 text-xs font-semibold text-cta" data-id="element-54" data-mp="2knipn6gujnhi">
              <CheckCircle2Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-55" data-mp="2plby665mgtky" />
              Verified · {minutesAgo} min ago
            </p>
          </div>
          <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-full p-1 text-muted transition-colors duration-150 hover:text-ink" aria-label="Close notification" data-id="element-56" data-mp="1wwn3opz2nmi6">
            <XIcon className="h-4 w-4" data-id="element-57" data-mp="26osuvxhi1zwb" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}